import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { hasClass } from '@utiljs/dom';
import locale from '../locale';

var Mark = /*#__PURE__*/function (_React$Component) {
  _inherits(Mark, _React$Component);

  var _super = _createSuper(Mark);

  function Mark() {
    var _this;

    _classCallCheck(this, Mark);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: _this.props.defaultValue,
      currentValue: _this.props.defaultValue,
      hoverValue: -1,
      pointerAtLeftHalf: false
    };
    _this.faceClassMap = ['frown', 'meh', 'smile'];
    _this.halIconStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      overflow: 'hidden',
      width: '50%'
    };

    _this.handleMouseMove = function (value, event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          allowHalf = _this$props.allowHalf;
      if (disabled) return;

      if (allowHalf) {
        _this.setCurrentValue(value, event);
      } else {
        _this.setState({
          hoverValue: value,
          currentValue: value
        });
      }
    };

    _this.handleMouseLeave = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          allowHalf = _this$props2.allowHalf;
      var value = _this.state.value;
      if (disabled) return;

      if (allowHalf) {
        _this.setState({
          pointerAtLeftHalf: value !== Math.floor(value)
        });
      }

      _this.setState({
        hoverValue: -1,
        currentValue: value
      });
    };

    _this.setCurrentValue = function (value, event) {
      var target = event.target;

      if (hasClass(target, 'roo-mark-item')) {
        target = target.querySelector('.roo-mark-icon');
      }

      if (hasClass(target, 'roo-mark-half-icon')) {
        target = target.parentNode;
      }

      var pointerAtLeftHalf = Boolean((event.clientX - target.getBoundingClientRect().left) * 2 < target.clientWidth);

      _this.setState({
        hoverValue: value,
        pointerAtLeftHalf: pointerAtLeftHalf,
        currentValue: pointerAtLeftHalf ? value - 0.5 : value
      });
    };

    _this.handleClickChange = function (value) {
      var _this$props3 = _this.props,
          propValue = _this$props3.value,
          disabled = _this$props3.disabled,
          allowHalf = _this$props3.allowHalf,
          onChange = _this$props3.onChange;
      var _this$state = _this.state,
          pointerAtLeftHalf = _this$state.pointerAtLeftHalf,
          currentValue = _this$state.currentValue;
      if (disabled) return;

      if (allowHalf && pointerAtLeftHalf) {
        if (propValue === undefined) {
          _this.setState({
            value: currentValue
          });
        }

        if (onChange) {
          onChange(currentValue);
        }
      } else {
        if (propValue === undefined) {
          _this.setState({
            currentValue: value,
            value: value
          });
        }

        if (onChange) {
          onChange(value);
        }
      }
    };

    _this.getRangeColorOrClass = function (currentValue, map) {
      var _this$props4 = _this.props,
          lowThreshold = _this$props4.lowThreshold,
          highThreshold = _this$props4.highThreshold;

      if (currentValue <= lowThreshold) {
        return map[0];
      }

      if (Math.ceil(currentValue) < highThreshold) {
        return map[1];
      }

      return map[2];
    };

    _this.getIconColor = function (value) {
      var _this$props5 = _this.props,
          colors = _this$props5.colors,
          voidColor = _this$props5.voidColor;
      var currentValue = _this.state.currentValue;

      if (value <= currentValue) {
        return {
          color: _this.getRangeColorOrClass(currentValue, colors)
        };
      }

      return {
        color: voidColor
      };
    };

    _this.getHalfIconColor = function () {
      var colors = _this.props.colors;
      var currentValue = _this.state.currentValue;

      var color = _this.getRangeColorOrClass(currentValue, colors);

      return {
        color: color
      };
    };

    _this.getIconClass = function (value) {
      var iconType = _this.props.iconType;
      var _this$state2 = _this.state,
          currentValue = _this$state2.currentValue,
          hoverValue = _this$state2.hoverValue;
      var icon = value <= currentValue ? 'star-fill' : 'star';

      if (iconType === 'face') {
        icon = value <= currentValue ? _this.getRangeColorOrClass(currentValue, _this.faceClassMap) : 'meh';
      }

      return classNames("roo-mark-icon icon icon-".concat(icon), {
        hover: value === hoverValue
      });
    };

    _this.getHalfIconClass = function () {
      var iconType = _this.props.iconType;
      var currentValue = _this.state.currentValue;
      var icon = '';
      icon = 'star-fill';

      if (iconType === 'face') {
        icon = _this.getRangeColorOrClass(currentValue, _this.faceClassMap);
      }

      return "roo-mark-icon icon icon-".concat(icon);
    };

    return _this;
  }

  _createClass(Mark, [{
    key: "showHalfIcon",
    value: function showHalfIcon(value) {
      var currentValue = this.state.currentValue;
      var allowHalf = this.props.allowHalf;
      return allowHalf && Math.ceil(currentValue) === value && Math.ceil(currentValue) !== currentValue;
    }
  }, {
    key: "renderHalfIcon",
    value: function renderHalfIcon(value) {
      if (!this.showHalfIcon(value)) return null;
      return /*#__PURE__*/React.createElement("i", {
        className: "roo-mark-half-icon ".concat(this.getHalfIconClass()),
        style: _Object$assign(this.getHalfIconColor(), this.halIconStyle)
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          style = _a.style,
          allowHalf = _a.allowHalf,
          voidColor = _a.voidColor,
          iconType = _a.iconType,
          showText = _a.showText,
          lowThreshold = _a.lowThreshold,
          highThreshold = _a.highThreshold,
          textColor = _a.textColor,
          restProps = __rest(_a, ["className", "style", "allowHalf", "voidColor", "iconType", "showText", "lowThreshold", "highThreshold", "textColor"]);

      var markList = [];

      var _loop = function _loop(value) {
        markList.push( /*#__PURE__*/React.createElement("span", _Object$assign({}, restProps, {
          key: "mark-".concat(value),
          className: classNames('roo-mark-item', className),
          style: style,
          onMouseMove: function onMouseMove(event) {
            return _this2.handleMouseMove(value, event);
          },
          onMouseLeave: _this2.handleMouseLeave,
          onClick: function onClick() {
            return _this2.handleClickChange(value);
          }
        }), /*#__PURE__*/React.createElement("i", {
          className: _this2.getIconClass(value),
          style: _this2.getIconColor(value)
        }, _this2.renderHalfIcon(value))));
      };

      for (var value = 1; value <= this.props.max; value++) {
        _loop(value);
      }

      return markList;
    }
  }, {
    key: "renderMarkText",
    value: function renderMarkText() {
      var _this$props6 = this.props,
          showText = _this$props6.showText,
          texts = _this$props6.texts,
          textColor = _this$props6.textColor;
      var currentValue = this.state.currentValue;
      if (!showText) return null;
      return /*#__PURE__*/React.createElement("span", {
        className: "roo-mark-text",
        style: {
          color: textColor
        }
      }, texts[currentValue - 1]);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-mark"
      }, this.renderContent(), this.renderMarkText());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.value !== undefined) {
        return {
          value: nextProps.value,
          currentValue: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Mark;
}(React.Component);

Mark.propTypes = {
  defaultValue: PropTypes.number,
  value: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  allowHalf: PropTypes.bool,
  lowThreshold: PropTypes.number,
  highThreshold: PropTypes.number,
  colors: PropTypes.array,
  voidColor: PropTypes.string,
  iconType: PropTypes.oneOf(['star', 'face']),
  showText: PropTypes.bool,
  texts: PropTypes.array,
  textColor: PropTypes.string,
  onChange: PropTypes.func
};
Mark.defaultProps = {
  defaultValue: 0,
  value: undefined,
  max: 5,
  disabled: false,
  allowHalf: false,
  lowThreshold: 2,
  highThreshold: 4,
  colors: ['#F7BA2A', '#F7BA2A', '#F7BA2A'],
  voidColor: '#C6D1DE',
  iconType: 'star',
  showText: false,
  texts: locale.lng('Mark.texts'),
  textColor: '',
  onChange: undefined
};
polyfill(Mark);
export default Mark;